import { extractDataForNode } from '../../chapter-aggregation/utils/chapter-compare';

export function aggregateProgram(programData) {
  let chapterDict = {};
  //console.log("Here 0" , programData)
  if (!programData) {
    return {
      chapterDict,
    };
  }
  programData.forEach(programNode => {
    if (chapterDict[programNode.chapter_code] === undefined) {
      chapterDict[programNode.chapter_code] = {};
    }
    if (
      chapterDict[programNode.chapter_code][programNode.chapter_version] === undefined
    ) {
      chapterDict[programNode.chapter_code][programNode.chapter_version] = [];
    }
    chapterDict[programNode.chapter_code][programNode.chapter_version].push(programNode);
  });

  //console.log("chapterDict", chapterDict);
  return { chapterDict };
}

export function extractDataForChapter(nodeList) {
  let medianScoreChp = 0;
  let maxScoreChp = 0;
  let q1ScoreChp = 0;
  let q3ScoreChp = 0;
  let q1TimeChp = 0;
  let q3TimeChp = 0;
  let medianTimeChp = 0;
  let assessmentMedianScoreChp = 0;
  let chapterLink = null;
  nodeList.forEach(node => {
    let {
      medianScore,
      maxScore,
      q1Score,
      q3Score,
      q1Time,
      q3Time,
      medianTime,
      worksheetLink,
    } = extractDataForNode(node);
    if (maxScore && medianScore) {
      maxScoreChp += maxScore;
      medianScoreChp += medianScore;
      q1ScoreChp += q1Score;
      q3ScoreChp += q3Score;
      q1TimeChp += q1Time;
      q3TimeChp += q3Time;
      medianTimeChp += medianTime;
      chapterLink += worksheetLink;
    }
  });

  let outObj = {
    medianScoreChp,
    q1ScoreChp,
    q3ScoreChp,
    medianTimeChp,
    q1TimeChp,
    q3TimeChp,
    assessmentMedianScoreChp,
    chapterLink,
    maxScoreChp,
  };
  return outObj;
}
